import React from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {Link} from 'react-router-dom'
import {Col, Row} from '../../common/bootstrap'
import isEqual from 'lodash-es/isEqual'
import * as articleActions from '@prepler/core/lib/actions/admin/articleActions'
import {articlesSelector} from '@prepler/core/lib/reducers/admin/articlesReducer'
import routesHelper from '@prepler/core/lib/routesHelper'
import withParams from '../../common/withParams'
import SearchInput from './../../common/searchInput'
import Pagination from './../../common/pagination'
import Article from './article'

class Articles extends React.Component {
	componentDidMount() {
		this.load();
	}

	componentDidUpdate(prevProps, prevState) {
		const {params} = this.props;
		if (!isEqual(prevProps.params, params)) {
			this.load();
		}
	}

	load() {
		const {params, actions: {loadAdminArticles}} = this.props;
		loadAdminArticles(params);
	}

	render () {
		const {articles, meta, params, setParams} = this.props;
		return <React.Fragment>
			<h2>Articles ({meta.total_count})</h2>
			<Row>
				<Col sm={2} md={2}>
					<Link to={routesHelper.adminArticleNewPath()} className="btn btn-default">Create</Link>
				</Col>
				<Col sm={6} md={6}>
					<Pagination params={params} setParams={setParams} meta={meta}/>
				</Col>
				<Col sm={4} md={4}>
					<SearchInput params={params} setParams={setParams}/>
				</Col>
			</Row>
			<table className="table table-bordered">
				<thead>
					<tr>
						<th>ID</th>
						<th>Name</th>
						<th>Published At</th>
						<th>Actions</th>
					</tr>
				</thead>
				<tbody>
					{articles.map(article => <Article key={article.id} article={article}/>)}
				</tbody>
			</table>
		</React.Fragment>;
	}
}

function mapStateToProps(state, ownProps) {
	return articlesSelector(state);
}

function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(articleActions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(withParams(Articles));
